<template>
  <div class="xcard">
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <h3 class="text-center text-primary">Generacion de certificados.</h3>
    <p class="text-center">Inscritos de: {{ pro }}</p>
    <p v-if="programita.universidad" class="text-center text-success">
      En Convenio con: {{ programita.universidad.nombre }}
    </p>
    <p class="text-center text-danger">
      <small> {{ msgimg }} </small>
    </p>

    <button :disabled="loading" class="btn btn-primary btn-sm" @click="iniciarGeneracion()">
      <span class="glyphicon glyphicon-check" style="color: white"></span> Generar Certificados de los que Faltan
    </button>
    <input
      :disabled="$store.state.CARGO.id == 13"
      type="checkbox"
      v-model="mostrarGrado"
      style="margin-left: 8px"
      title="Funcion no disponible para asesores." />
    Mostrar Grados Academicos <small class="xfuente">...</small>
    <!-- Esto permite cargar la fuente .ttf -->
    <small class="xcert-titulo">...</small>
    <!-- Esto permite cargar la fuente .ttf -->
    <small class="xcert-pie">...</small>
    <!-- Esto permite cargar la fuente .ttf -->
    <small class="xcert-pie">...</small>
    <!-- Esto permite cargar la fuente .ttf -->
    <small class="xcert-piebold">...</small>
    <!-- Esto permite cargar la fuente .ttf -->
    <v-row>
      <v-col cols="5">
        <v-text-field outlined v-model.trim="buscar" placeholder="Buscar en esta tabla..." />
        <!-- <input type="text" class="form-control input-sm" style="max-width:200px!;display:inline-block" v-model="buscar" placeholder="Buscar en la tabla"> -->
      </v-col>
      <v-col>
        <span class="blue--text">Seleccione un postitulo para generar los certificados:</span>
        <v-select
          dense
          outlined
          :items="postitulos"
          v-model="postitulo"
          return-object
          item-text="text"
          clearable
          prepend-inner-icon="mdi-map"
          placeholder="Postitulos..."></v-select>
      </v-col>
    </v-row>

    <!-- <Alertas ref="c_alertar" /> -->
    <v-progress-linear indeterminate v-if="loading" />
    <button class="btn btn-link btn-sm" @click="selcheck(true)">
      <span class="glyphicon glyphicon-check"></span> Todos
    </button>
    <button class="btn btn-link btn-sm" @click="selcheck(false)">
      <span class="glyphicon glyphicon-unchecked"></span> Ninguno
    </button>
    <button class="btn btn-link btn-sm" @click="seleccionarDiez()">
      <span class="glyphicon glyphicon-th-list"></span> De 10 en 10
    </button>

    <div class="table-responsive">
      <table ref="table" class="table table-condensed table-striped table-hover" id="midatatable">
        <thead>
          <tr>
            <th><small>Nro</small></th>
            <th><small>Estudiante</small></th>
            <th><small>Documento</small></th>
            <th><small>Tel.</small></th>
            <th><small>Correo</small></th>
            <th><small>Certificado</small></th>
            <th style="min-width: 160px"><small>Opciones</small></th>
          </tr>
        </thead>

        <tbody>
          <tr v-bind:key="ind" v-for="(e, ind) in estudiantes">
            <td>
              <small>{{ ind + 1 }}</small>
            </td>
            <td>
              <input
                :disabled="e.estado_ins == 0 || !e.sindeuda"
                type="checkbox"
                v-model="e.check"
                style="padding: 0; margin: 0" />
              <small
                ><input type="text" v-model="e.nombres" style="padding: 0; margin: 0; border: 0; width: 200px"
              /></small>
            </td>
            <td>
              <small>{{ e.num_doc }}</small>
            </td>
            <td>
              <small>{{ e.telefono1 }}</small>
            </td>
            <td>
              <small>{{ e.email }}</small> <span style="display: none">{{ e.nombres }}</span>
            </td>
            <td :title="e.title">
              <div v-if="e.estado == 3 || e.estado == 1" class="loader"></div>
              <div v-else-if="e.estado == 2" class="dot-green"></div>
              <small v-else> <span class="dot-red" :title="e.estado"></span> {{ parseEstado(e) }} </small>
              <small> {{ e.certificado_id }}</small>
            </td>
            <td>
              <button
                :disabled="!e.certificado_id"
                title="Ver Certificado"
                class="btn btn-xs btn-default"
                data-toggle="modal"
                data-target="#modal-cert"
                @click="decargar(e, false)">
                <span class="glyphicon glyphicon-eye-open"></span>
              </button>
              <button
                v-show="sede_permitida"
                :disabled="e.certificado_id || e.estado_ins == 0 || !e.sindeuda || $store.state.CARGO.id == -13"
                title="Generar Certificado.."
                class="btn btn-xs btn-default"
                @click="generarCertificadospre(e, result, 2, 1)">
                <span class="glyphicon glyphicon-refresh"></span>
              </button>
              <button
                v-show="sede_permitida"
                :disabled="!e.certificado_id || $store.state.CARGO.id == 13"
                title="Anular Certificado"
                class="btn btn-xs btn-default"
                @click="preAnularcertificado(e)">
                <span class="glyphicon glyphicon-trash"></span>
              </button>
              <button
                v-show="sede_permitida"
                :disabled="!(e.estado >= 2)"
                title="Descargar Certificado"
                class="btn btn-xs btn-default"
                @click="decargar(e, true)">
                <span class="glyphicon glyphicon-save"></span>
              </button>
              <button
                v-show="sede_permitida"
                :disabled="!(e.estado >= 2)"
                title="Enviar por correo"
                class="btn btn-xs btn-default"
                @click="alistarUnPdfServer(e, 2, 1)">
                <span class="glyphicon glyphicon-send"></span>
              </button>
              <button
                v-show="sede_permitida"
                :disabled="!(e.estado >= 2)"
                title="Enviar por WhatsApp"
                class="btn btn-xs btn-default"
                @click="enviarPorWhatsapp(e)">
                <span class="glyphicon glyphicon-comment"></span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div style="width: 10px !important; height: 1px !important; overflow: hidden">
      <canvas id="myCanvas3" style="border: 1px solid #55d3d3d3"></canvas>
    </div>
    <small class="text-primary"> {{ image ? image.src : '' }} </small>
    <p class="text-primary">{{ mensaje }}</p>

    <button
      :disabled="loading"
      v-show="estudiantes.length > 15"
      class="btn btn-primary btn-sm"
      @click="iniciarGeneracion()">
      <span class="glyphicon glyphicon-check" style="color: white"></span> Generar Certificados de los que Faltan
    </button>
    <button
      class="btn btn-success btn-sm"
      :disabled="!descargartodo"
      @click="descargarTodos()"
      style="margin-left: 4px">
      <span class="glyphicon glyphicon-save" style="color: white"></span> Descargar Certificados en PDF's
    </button>
    <button
      class="btn btn-warning btn-sm"
      :disabled="!descargartodo || loading"
      @click="generarParaCorreos()"
      style="margin-left: 4px">
      <span class="glyphicon glyphicon-envelope" style="color: white"></span> Enviar Certificados Por Correo a Todos
    </button>
    <v-btn v-show="estudiantes.length > 15" small class="mx-4" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <notifications group="auth" position="bottom right" />
    <notifications group="auth3" position="bottom right" />
    <modalc id="modalemail" v-bind:correos="correos" v-bind:xbody="xbody" v-on:exito="modalExitoCorreo" />

    <div class="modal" tabindex="-1" role="dialog" id="modal-cert">
      <div class="modal-dialog" role="document">
        <div class="modal-content" style="overflow: hidden" id="content-preview">
          <div class="modal-header">
            <h5 class="modal-title text-center"><b> Certificado </b></h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <p class="text-primary text-center">{{ mensajito }}</p>
            <canvas id="myCanvasview" style="border: 0px solid #55d3d3d3"></canvas>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
          </div>
        </div>
      </div>
    </div>

    <div style="overflow: hidden; width: 2px !important; height: 2px !important" id="cueres">
      <div id="qrcode1"></div>
      <div id="qrcode2"></div>
    </div>

    <small v-show="$store.state.CARGO.id == 7">
      <small>
        <input type="checkbox" v-model="is_formacion_continua" title="is_formacion_continua" />
        {{ is_formacion_continua }}
      </small>
      <small> <input type="checkbox" v-model="is_fc_id498" title="is_fc_id498" /> {{ is_fc_id498 }} </small>
    </small>

    <CertificadosTodosFecha ref="refCertificadosTodosFecha" v-on:success="setFechaEmision" />
  </div>
</template>

<style lang="css">
  .dot-green {
    height: 10px;
    width: 10px;
    background-color: #00aa00;
    border-radius: 50%;
    display: inline-block;
  }
  .dot-red {
    height: 10px;
    width: 10px;
    background-color: #aa0000;
    border-radius: 50%;
    display: inline-block;
  }

  .loader {
    border: 4px solid #f3f3f3; /* Light grey */
    border-top: 4px solid blue; /* Blue */
    border-bottom: 4px solid blue;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    animation: spin 1.2s linear infinite;
  }
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>

<script>
  // import Alertas from '@/components/AAlertas.vue';
  import { parseJsonError, getCleanedString, exito } from '@/components/Utils.js';
  import modalc from '@/components/ACorreoCertificados.vue';
  import gql from 'graphql-tag';
  import xaxios from '@/xaxios';
  import CertificadosTodosFecha from './CertificadosTodosFecha.vue';
  import { mapState } from 'vuex';
  export default {
    data() {
      return {
        is_fc_id498: false,
        is_fc_id854: false,
        is_only_nombres: false,
        is_only_nombresv2: false,
        is_formacion_continua: false,
        is_formacion_continua_esam: false,
        is_curso_trans_dig: false,
        loading: false,
        is_cca: false,
        pro: '',
        image: null,
        result: null,
        tam: 120,
        msgimg: '',
        originalimg: '',
        api_rest: process.env.VUE_APP_API_REST,
        xbody: `Hola $nombre, la *${process.env.VUE_APP_NAME}* le saluda y le felicita por tener a la institución como la primera opción para continuar con su desarrollo personal y profesional. \n\nPor este medio le envío el enlace de su certificado del: \n$pro, para que pueda descargarlo en formato PDF. \n\nAnte cualquier duda o consulta, no dude en contactarme por este medio, a fin de guiarle u orientarle. \n\n $link`,
        //xbody:'Hola $nombre, a continuacion le enviamos el link del certificado para descargarlo en formato PDF:',
        mensajito: 'Cargando vista previa....',
        mensaje: '',
        buscar: '',
        programita: { universidad: {} },
        descargartodo: false,
        idprograma: -1,
        estudiantes: [], //id_ins nombres num_doc email certificado_id estado_ins estado
        cetificados_uids: [], //inscripcion_id id codigo nro
        certificados: [],
        correos: [],
        correo: {},
        mostrarGrado: false,
        idsede: -1,

        c_indice: 0,
        sede_permitida: false,
        loadingpostitulos: false,
        postitulos: [],
        postitulo: null,
        fecha_emision: null,
      };
    },
    components: { modalc,CertificadosTodosFecha },
    computed: { ...mapState({ programa: (state) => state.programa.value }) },
    watch: {
      buscar: function () {
        this.myFunction1(this.buscar);
      },
      mostrarGrado: function () {
        this.listarEstudiantes();
      },
      '$store.state.CARGOS': function () {
        if (this.idsede > 0) {
          this.isSedePermitida(this.idsede);
        }
      },
      postitulo: function () {
        this.postituloselect();
      },
    },
    methods: {
      modalExitoCorreo() {},
      setFechaEmision(f){
        this.fecha_emision = f;
        // window.console.log('this.fecha_emision:',this.fecha_emision);
      },
      isSedePermitida(sede_actual) {
        var sed = this.$store.state.CARGOS.find((x) => x.idsede == sede_actual);
        this.sede_permitida = sed != null;
      },
      selcheck(estado) {
        this.c_indice = 0;
        this.estudiantes.forEach(function (e) {
          e.check = estado && e.sindeuda;
        });
      },
      postituloselect() {
        window.console.log('Postitulo seleccionado', this.postitulo);
        window.console.log('this.programita', this.programita);
        let ximg = process.env.VUE_APP_URL_CERT_PROGRAMAS + this.programita.arte;
        if( !(ximg+'').includes('default') ){
          this.originalimg = ximg;
          this.cargarFondoCertificado(ximg);
        }
        if (!this.postitulo) return;
        /*let idu = this.postitulo.universidad;
        let idpo = this.programita.id;
        //const omit = this.programita.id == 485;
        const omit = this.programita.id > 52;
        if (idu == 52 && !omit) {
          let img = 'img/webina.png'; 
          if (idpo == 2804) {
            img = 'img/xcurso.jpg';
          }
          this.originalimg = img;
          this.cargarFondoCertificado(img);
        }*/
      },
      seleccionarDiez() {
        this.estudiantes.forEach(function (e) {
          e.check = false;
        });
        var i = 0;
        for (i = this.c_indice; i < this.c_indice + 10; i++) {
          if (this.estudiantes.length > i) this.estudiantes[i].check = this.estudiantes[i].sindeuda;
        }
        this.c_indice = i;
        if (i > this.estudiantes.length) this.c_indice = 0;
      },
      parseEstado(es) {
        if (es.estado_ins == 0) return 'Preinscrito.';
        else if (!es.sindeuda) return 'Tiene Deuda.';
        else if (es.estado == 0) return 'SIN CERTIFICADO';
        else if (es.estado == 1) return 'GENERANDO...';
        else if (es.estado == 2) return 'GENERADO';
        else if (es.estado == 3) return 'DESCARGANDO...';
        else return 'nothing ';
      },
      wordWrapToStringList(text, maxLength) {
        var result = [],
          line = [];
        var length = 0;
        text.split(' ').forEach(function (word) {
          if (length + word.length >= maxLength) {
            result.push(line.join(' '));
            line = [];
            length = 0;
          }
          length += word.length + 1;
          line.push(word);
        });
        if (line.length > 0) {
          result.push(line.join(' '));
        }
        return result;
      },
      parseFecha(f) {
        if (f == null) return '';
        var fs = f.split('-');
        return fs[2] + '/' + fs[1] + '/' + fs[0];
      },
      parseMes(m) {
        m = m - 1;
        if (m == 0) return 'ENERO';
        else if (m == 1) return 'FEBRERO';
        else if (m == 2) return 'MARZO';
        else if (m == 3) return 'ABRIL';
        else if (m == 4) return 'MAYO';
        else if (m == 5) return 'JUNIO';
        else if (m == 6) return 'JULIO';
        else if (m == 7) return 'AGOSTO';
        else if (m == 8) return 'SEPTIEMBRE';
        else if (m == 9) return 'OCTUBRE';
        else if (m == 10) return 'NOVIEMBRE';
        else if (m == 11) return 'DICIEMBRE';
      },
      parsePrograma(p) {
        if(p.id==4484) p.nombre_compuesto = "REGLAMENTO DE SERVICIO PÚBLICO DE SUMINISTRO DE ELECTRICIDAD Y REGLAMENTO PARA EL USO DE BIENES DE DOMINIO PÚBLICO Y CONSTITUCIÓN DE SERVIDUMBRE";
        if (p == null) return '';
        var post = '';
        if (p.postgrado != null) post = p.postgrado.nombre;
        post = post.replace('Curso en', ' ');
        // post = post.replace('Curso ', ' ');
        post = post.replace('CURSOS DE FORMACIÓN CONTINUA', 'CURSO ');
        post = post.replace('CURSOS DE FORMACIÓN CONTINUA', ' ');
        return post + ' version:' + p.version + ', gestion:' + p.gestion;
      },
      cargarQRleft(sha, estudiante) {
        var p = `${process.env.VUE_APP_URL_VALIDATOR}?idestudiante=esamestudent&idprograma=` + sha;
        var options = {
          text: p,
          width: 1024,
          height: 1024,
          version: 0,
          dotScale: 1,
          correctLevel: window.QRCode.CorrectLevel.M,
          onRenderingEnd: this.renderingEnd(),
        };
        var tag = document.createElement('div');
        var element = document.getElementById('cueres');
        element.appendChild(tag);
        //estudiante.qr1 = qr.toImage("png");
        /*new window.QRCode(document.getElementById("qrcode1"), options);
      estudiante.qr1 = document.getElementById("qrcode1").childNodes[0];*/
        new window.QRCode(tag, options);
        estudiante.qr1 = tag.childNodes[0];
      },
      cargarQRRight(es) {
        //window.console.log( 'QR @::::: programaita,',this.programita );
        var str = 'DATOS:\n\n';
        str += 'Estudiante: ' + es.nombres + '\n';
        str += '\n\n' + this.programita.nombre_compuesto.toUpperCase();
        str +=
          '\n\nRealizado del ' +
          this.parseFecha(this.programita.fecha_inicio) +
          ' AL ' +
          this.parseFecha(this.programita.fecha_fin);
        var p = str;
        var options = {
          text: p,
          width: 1024,
          height: 1024,
          version: 0,
          dotScale: 1,
          correctLevel: window.QRCode.CorrectLevel.L,
          onRenderingEnd: this.renderingEnd(),
        };
        //es.qr2 = qr.toImage("png");
        var tag = document.createElement('div');
        var element = document.getElementById('cueres');
        element.appendChild(tag);

        /*new window.QRCode(document.getElementById("qrcode2"), options);
      es.qr2 = document.getElementById("qrcode2").childNodes[0];*/
        new window.QRCode(tag, options);
        es.qr2 = tag.childNodes[0];
      },
      renderingEnd() {},

      /*cargarDatosCanvasCursoTransDig(certificado, estudiante) {
        var canvas = document.getElementById('myCanvas3').cloneNode(true);
        canvas.width = 1280;
        canvas.height = 908;
        canvas.style.width = '1280px';
        canvas.style.height = '908px';
        var context = canvas.getContext('2d');

        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(this.image, 0, 0, 1280, 908);

        context.font = '10px Arial';
        context.fillText('verificador:', 130, 750);
        context.fillText('estudiante:', 1095, 750);

        context.drawImage(estudiante.qr1, 107, 757, this.tam - 20, this.tam - 20);
        context.drawImage(estudiante.qr2, 1065, 757, this.tam - 20, this.tam - 20);

        context.fillStyle = '#eeffff';
        context.font = '14px Arial';
        context.fillText('000000000' + certificado.nro, canvas.width / 2 + 510, 55);
        context.fillStyle = '#000000';

        context.font = '35px xfuente';
        context.textAlign = 'center';
        context.fillText('' + estudiante.nombres, canvas.width / 2, 397);
        estudiante.canvas = canvas;
      },*/
      cargarDatosCustomCCA2(certificado, estudiante) {
        var canvas = document.getElementById('myCanvas3').cloneNode(true);
        canvas.width = 1280;
        canvas.height = 908;
        canvas.style.width = '1280px';
        canvas.style.height = '908px';
        var context = canvas.getContext('2d');

        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(this.image, 0, 0, 1280, 908);

        context.font = '10px Arial';
        context.fillText('verificador:', 120, 745);
        context.drawImage(estudiante.qr1, 90, 748, this.tam, this.tam);
        if (this.is_formacion_continua) {
          context.drawImage(estudiante.qr2, 1075, 748, this.tam, this.tam);
          context.fillText('estudiante:', 1105, 755);
        } else {
          context.drawImage(estudiante.qr2, 1065, 748, this.tam, this.tam);
          context.fillText('estudiante:', 1095, 745);
        }

        context.fillStyle = '#eeffff';
        context.font = '200 14px xfuente';
        if (this.programita.id == 693 || this.programita.id == 704) {
          context.fillText('000000000' + certificado.nro, canvas.width / 2 + 505, 55);
        } else {
          context.fillText('000000000' + certificado.nro, canvas.width / 2 + 505, 55);
        }
        context.fillStyle = '#000000';

        var times = certificado.fecha_registro.split('T')[0];
        var fecha = times;
        var ps = fecha.split('-');
        var dia = ps[2];
        var mes = ps[1];
        var anio = ps[0];
        var messtr = this.parseMes(mes);
        dia = parseInt(dia);

        context.font = '200 30px xfuente';
        context.textAlign = 'center';
        //window.console.log( 'HOLA MUNDO:::::::',this.is_fc_id854 );

        if (this.is_fc_id498) {
          context.fillText('' + estudiante.nombres, canvas.width / 2 + 0, 395);
        } else if (this.is_formacion_continua) context.fillText('' + estudiante.nombres, canvas.width / 2 + 0, 505);
        else context.fillText('' + estudiante.nombres, canvas.width / 2 + 50, 505);

        if (!this.is_formacion_continua) {
          var pp = certificado.curso;
          if (pp.length > 65) {
            pp = this.wordWrapToStringList(pp, 65);
            var tt = 585;
            //var vue = this;
            pp.forEach(function (e) {
              context.font = '200 23px xfuente';
              context.fillText('' + e, canvas.width / 2 + 50, tt);
              tt += 22;
            });
          } else {
            context.font = '200 30px xfuente';
            context.fillText('' + pp, canvas.width / 2 + 50, 595);
          }
          context.font = '200 23px xfuente';
          context.fillText('' + certificado.carga_horaria, canvas.width / 2 + 10, 644);
          context.fillText('' + dia, canvas.width / 2 - 80, 679);
          context.font = '200 17px xfuente';
          context.fillText('' + messtr, canvas.width / 2 + 178, 679);
          context.font = '200 23px xfuente';
          //context.fillText(""+certificado.lugar, (canvas.width/2)-90, 710);
          context.fillText('' + anio, canvas.width / 2 + 350, 679);
        }

        estudiante.canvas = canvas;
      },
      /*cargarDatosCanvasCustom200(certificado, estudiante) {
        var canvas = document.getElementById('myCanvas3').cloneNode(true);
        canvas.width = 1280;
        canvas.height = 908;
        canvas.style.width = '1280px';
        canvas.style.height = '908px';
        var context = canvas.getContext('2d');

        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(this.image, 0, 0, 1280, 908);

        context.font = '10px Arial';
        context.fillText('verificador:', 310, 792);
        context.fillText('estudiante:', 1195, 792);

        context.drawImage(estudiante.qr1, 282, 795, this.tam - 20, this.tam - 20);
        context.drawImage(estudiante.qr2, 1173, 795, this.tam - 20, this.tam - 20);

        context.fillStyle = '#eeffff';
        context.font = '14px Arial';
        context.fillText('000000000' + certificado.nro, canvas.width / 2 + 525, 25);
        context.fillStyle = '#000000';

        context.font = '30px xfuente';
        context.textAlign = 'center';
        context.fillText('' + estudiante.nombres, canvas.width / 2 + 150, 480);
        estudiante.canvas = canvas;
      },*/
      cargarDatosCanvasCustom1565(certificado, estudiante) {
        window.console.log('>>> hola::');
        var canvas = document.getElementById('myCanvas3').cloneNode(true);
        canvas.width = 1280;
        canvas.height = 908;
        canvas.style.width = '1280px';
        canvas.style.height = '908px';
        var context = canvas.getContext('2d');

        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(this.image, 0, 0, 1280, 908);

        context.font = '10px Arial';
        context.fillText('verificador:', 310, 792);
        context.fillText('estudiante:', 1195, 792);

        context.drawImage(estudiante.qr1, 282, 795, this.tam - 20, this.tam - 20);
        context.drawImage(estudiante.qr2, 1173, 795, this.tam - 20, this.tam - 20);

        context.fillStyle = '#eeffff';
        context.font = '14px Arial';
        context.fillText('000000000' + certificado.nro, canvas.width / 2 + 525, 25);
        context.fillStyle = '#000000';

        context.font = '30px xfuente';
        context.textAlign = 'center';
        context.fillText('' + estudiante.nombres, canvas.width / 2 + 150, 480);
        estudiante.canvas = canvas;
      },
      /*cargarDatosCanvasOnlyEstudent(certificado, estudiante) {
        var canvas = document.getElementById('myCanvas3').cloneNode(true);
        canvas.width = 1280;
        canvas.height = 908;
        canvas.style.width = '1280px';
        canvas.style.height = '908px';
        var context = canvas.getContext('2d');

        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(this.image, 0, 0, 1280, 908);

        context.font = '10px Arial';
        context.fillText('estudiante:', 310, 792);
        context.fillText('verificador:', 1195, 792);

        context.drawImage(estudiante.qr2, 282, 795, this.tam - 20, this.tam - 20);
        context.drawImage(estudiante.qr1, 1173, 795, this.tam - 20, this.tam - 20);

        context.fillStyle = '#eeffff';
        context.font = '14px Arial';
        context.fillText('000000000' + certificado.nro, canvas.width / 2 + 525, 25);
        context.fillStyle = '#000000';

        context.font = '30px xfuente';
        context.textAlign = 'center';
        if (estudiante.nombres.length > 40) context.font = '25px xfuente';
        context.fillText('' + estudiante.nombres, canvas.width / 2 + 150, 480);
        estudiante.canvas = canvas;
      },*/
      /*cargarDatosCanvasOnlyEstudent1544(certificado, estudiante) {
        var canvas = document.getElementById('myCanvas3').cloneNode(true);
        canvas.width = 1280;
        canvas.height = 908;
        canvas.style.width = '1280px';
        canvas.style.height = '908px';
        var context = canvas.getContext('2d');

        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(this.image, 0, 0, 1280, 908);
        context.beginPath();
        context.lineWidth = '16';
        context.strokeStyle = 'white';
        context.rect(1175, 789, this.tam - 25, this.tam - 15);
        context.stroke();

        context.font = '10px Arial';
        //context.fillText("estudiante:", 310, 792);
        context.fillText('verificador:', 1195, 792);

        //context.drawImage(estudiante.qr2, 282, 795, this.tam-20, this.tam-20);
        context.drawImage(estudiante.qr1, 1173, 795, this.tam - 20, this.tam - 20);

        context.fillStyle = '#eeffff';
        context.font = '14px Arial';
        context.fillText('000000000' + certificado.nro, canvas.width / 2 + 525, 25);
        context.fillStyle = '#000000';

        context.font = '30px xfuente';
        context.textAlign = 'center';
        if (estudiante.nombres.length > 40) context.font = '25px xfuente';
        context.fillText('' + estudiante.nombres, canvas.width / 2 + 50, 445);
        estudiante.canvas = canvas;
      },*/
      /*cargarDatosCanvasOnlyEstudentV2(certificado, estudiante) {
        var canvas = document.getElementById('myCanvas3').cloneNode(true);
        canvas.width = 1280;
        canvas.height = 908;
        canvas.style.width = '1280px';
        canvas.style.height = '908px';
        var context = canvas.getContext('2d');

        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(this.image, 0, 0, 1280, 908);

        context.font = '10px Arial';
        context.fillText('estudiante:', 335, 770);
        context.fillText('verificador:', 1165, 770);

        context.drawImage(estudiante.qr2, 302, 773, this.tam, this.tam);
        context.drawImage(estudiante.qr1, 1130, 773, this.tam, this.tam);

        context.fillStyle = '#eeffff';
        context.font = '14px Arial';
        context.fillText('000000000' + certificado.nro, canvas.width / 2 + 525, 25);
        context.fillStyle = '#000000';

        context.font = '30px xfuente';
        context.textAlign = 'center';
        if (estudiante.nombres.length > 40) context.font = '25px xfuente';
        context.fillText('' + estudiante.nombres, canvas.width / 2 + 150, 470);
        estudiante.canvas = canvas;
      },*/
      /*cargarDatosCanvasCustom119(certificado, estudiante) {
        var canvas = document.getElementById('myCanvas3').cloneNode(true);
        canvas.width = 1280;
        canvas.height = 908;
        canvas.style.width = '1280px';
        canvas.style.height = '908px';
        var context = canvas.getContext('2d');

        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(this.image, 0, 0, 1280, 908);

        context.font = '10px Arial';
        context.fillText('verificador:', 137, 752);
        context.fillText('estudiante:', 1085, 752);

        context.drawImage(estudiante.qr1, 107, 760, this.tam - 20, this.tam - 20);
        context.drawImage(estudiante.qr2, 1068, 760, this.tam - 20, this.tam - 20);

        context.fillStyle = '#eeffff';
        context.font = '14px Arial';
        context.fillText('000000000' + certificado.nro, canvas.width / 2 + 510, 50);
        context.fillStyle = '#000000';

        context.font = '32px xfuente';
        context.textAlign = 'center';
        context.fillText('' + estudiante.nombres, canvas.width / 2, 398);
        estudiante.canvas = canvas;
      },*/
      cargarDatosCanvasCustom584(certificado, estudiante) {
        certificado.lugar = certificado.lugar.replace('DE LA SIERRA', '');
        certificado.curso = certificado.curso.replace('CURSO EN ', '');
        certificado.curso = certificado.curso.replace('CURSO ', '');
        certificado.curso = certificado.curso.replace('ESAM CURSOS', '');
        certificado.curso = certificado.curso.replace(
          'CURSOS DE FORMACIÓN CONTINUA CURSOS DE FORMACIÓN CONTINUA',
          'CURSO ',
        );
        certificado.curso = certificado.curso.replace('CURSOS DE FORMACIÓN CONTINUA', '');
        var canvas = document.getElementById('myCanvas3').cloneNode(true);
        canvas.width = 1280;
        canvas.height = 908;
        canvas.style.width = '1280px';
        canvas.style.height = '908px';
        var context = canvas.getContext('2d');

        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(this.image, 0, 0, 1280, 908);
        context.fillStyle = '#eeffff';
        context.font = '14px Arial';
        context.fillText('000000000' + certificado.nro, canvas.width / 2 - 630, 20);
        context.fillStyle = '#000000';

        var times = certificado.fecha_registro.split('T')[0];
        var fecha = times;
        var ps = fecha.split('-');
        var dia = ps[2];
        var mes = ps[1];
        var anio = ps[0];
        var messtr = this.parseMes(mes);
        dia = parseInt(dia);

        context.font = '35px xfuente';
        context.textAlign = 'center';
        if (this.is_formacion_continua) context.fillText('' + estudiante.nombres, canvas.width / 2 + 150, 380);
        else context.fillText('' + estudiante.nombres, canvas.width / 2 - 200, 360);
        if (!this.is_formacion_continua) {
          context.font = '300 23px xfuente';
          context.font = '300 26px xfuente';
          context.fillText('' + dia, canvas.width / 2 - 400, 570);
          context.fillText('' + messtr, canvas.width / 2 - 180, 570);
          context.fillText('' + anio, canvas.width / 2 + 120, 570);
        }
        estudiante.canvas = canvas;
      },
      /*cargarDatosCanvasUAJMS(certificado, estudiante) {
        window.console.log('MY CERT UAJMS>>>>', this.programita, this.is_only_nombres);

        certificado.lugar = certificado.lugar.replace('DE LA SIERRA', '');
        // certificado.curso = certificado.curso.replace('CURSO DE ', '');
        certificado.curso = certificado.curso.replace('CURSO EN ', '');
        certificado.curso = certificado.curso.replace('CURSO ', '');
        certificado.curso = certificado.curso.replace('ESAM CURSOS', '');
        var canvas = document.getElementById('myCanvas3').cloneNode(true);
        canvas.width = 1280;
        canvas.height = 908;
        canvas.style.width = '1280px';
        canvas.style.height = '908px';
        var context = canvas.getContext('2d');

        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(this.image, 0, 0, 1280, 908);

        context.font = '10px Arial';
        context.fillText('verificador:', 220, 226);
        context.fillText('estudiante:', 1080, 226);

        context.drawImage(estudiante.qr1, 180, 230, this.tam, this.tam);
        context.drawImage(estudiante.qr2, 1050, 230, this.tam, this.tam);

        context.fillStyle = '#eeffff';
        context.font = '14px Arial';
        let code = (certificado.nro + '').padStart(10, '0');
        context.fillText(code, canvas.width / 2 + 525, 25);
        context.fillStyle = '#000000';

        var times = certificado.fecha_registro.split('T')[0];
        var fecha = times;
        var ps = fecha.split('-');
        var dia = ps[2];
        var mes = ps[1];
        var anio = ps[0];
        var messtr = this.parseMes(mes);
        dia = parseInt(dia);

        context.font = '30px xcert-titulo';
        context.textAlign = 'center';
        context.fillText('' + estudiante.nombres, canvas.width / 2, 465);

        var pp = certificado.curso;
        let limit_width = 52;
        if (pp.length >= limit_width) {
          pp = this.wordWrapToStringList(pp, limit_width);
          var tt = 565;
          pp.forEach(function (e) {
            context.font = '300 27px xcert-titulo';
            context.fillText('' + e, canvas.width / 2, tt);
            tt += 28;
          });
        } else {
          context.font = '300 30px xcert-titulo';
          context.fillText('' + pp, canvas.width / 2, 590);
        }

        context.font = '300 23px xcert-piebold';
        context.fillText('' + certificado.carga_horaria, canvas.width / 2 + 60, 670);
        window.console.log(dia, anio, messtr);
        if (certificado.lugar.length > 12) {
          context.font = '300 19px xcert-piebold';
          context.fillText('' + certificado.lugar, canvas.width / 2 - 230, 730);
        } else {
          context.fillText('' + certificado.lugar, canvas.width / 2 - 230, 730);
        }
        context.font = '300 23px xcert-piebold';
        context.fillText('' + dia, canvas.width / 2 + 5, 730);
        context.fillText('' + messtr, canvas.width / 2 + 340, 731);
        context.fillText('' + anio, canvas.width / 2 + 530, 731);
        // let dado = `Es dado en ${certificado.lugar} a los ${dia} del mes de ${messtr} del ${anio}`;
        // context.fillText(dado, (canvas.width/2), 730);

        estudiante.canvas = canvas;
      },*/
      /*cargarDatosCanvasCCA_UAJMS(certificado, estudiante) {
        window.console.log('MY CERT CCA UAJMS>>>>', this.programita, this.is_only_nombres);
        if (this.programita.id == 1565) {
          this.cargarDatosCanvasCustom1565(certificado, estudiante);
          return;
        }

        certificado.lugar = certificado.lugar.replace('DE LA SIERRA', '');
        // certificado.curso = certificado.curso.replace('CURSO DE ', '');
        certificado.curso = certificado.curso.replace('CURSO EN ', '');
        certificado.curso = certificado.curso.replace('CURSO ', '');
        certificado.curso = certificado.curso.replace('ESAM CURSOS', '');
        var canvas = document.getElementById('myCanvas3').cloneNode(true);
        canvas.width = 1280;
        canvas.height = 908;
        canvas.style.width = '1280px';
        canvas.style.height = '908px';
        var context = canvas.getContext('2d');

        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(this.image, 0, 0, 1280, 908);

        context.font = '10px Arial';
        context.fillText('verificador:', 360, 777);
        context.fillText('estudiante:', 1135, 777);

        context.drawImage(estudiante.qr1, 320, 780, this.tam, this.tam);
        context.drawImage(estudiante.qr2, 1100, 780, this.tam, this.tam);

        context.fillStyle = '#eeffff';
        context.font = '14px Arial';
        let code = (certificado.nro + '').padStart(10, '0');
        context.fillText(code, canvas.width / 2 + 525, 25);
        context.fillStyle = '#000000';

        var times = certificado.fecha_registro.split('T')[0];
        var fecha = times;
        var ps = fecha.split('-');
        var dia = ps[2];
        var mes = ps[1];
        var anio = ps[0];
        var messtr = this.parseMes(mes);
        dia = parseInt(dia);

        context.font = '30px xfuente';
        context.textAlign = 'center';
        context.fillText('' + estudiante.nombres, canvas.width / 2 + 100, 480);

        var pp = certificado.curso;
        let limit_width = 52;
        if (pp.length >= limit_width) {
          pp = this.wordWrapToStringList(pp, limit_width);
          var tt = 565;
          pp.forEach(function (e) {
            context.font = '300 27px xfuente';
            context.fillText('' + e, canvas.width / 2 + 100, tt);
            tt += 28;
          });
        } else {
          context.font = '300 30px xfuente';
          context.fillText('' + pp, canvas.width / 2 + 100, 590);
        }

        //window.console.log('programiiii',this.programita);
        let fs1 = this.programita.fecha_inicio.split('-');
        let fs2 = this.programita.fecha_fin.split('-');
        let d1 = fs1[2];
        let m1 = this.getMesStr(fs1[1]);
        let a1 = fs1[0];
        let d2 = fs2[2];
        let m2 = this.getMesStr(fs2[1]);
        let a2 = fs2[0];

        context.font = '300 18px xfuente';
        context.fillText('' + certificado.carga_horaria, canvas.width / 2 + 130, 642);
        context.fillText('' + certificado.lugar, canvas.width / 2 + 170, 754);
        context.fillText('' + dia, canvas.width / 2 + 240, 754);
        context.fillText('' + messtr, canvas.width / 2 + 365, 754);
        context.fillText('' + anio, canvas.width / 2 + 530, 754);

        context.fillText('' + d1, canvas.width / 2 - 140, 692);
        context.fillText('' + m1, canvas.width / 2 - 30, 692);
        context.fillText('' + a1, canvas.width / 2 + 85, 692);
        context.fillText('' + d2, canvas.width / 2 + 180, 692);
        context.fillText('' + m2, canvas.width / 2 + 300, 692);
        context.fillText('' + a2, canvas.width / 2 + 460, 692);

        estudiante.canvas = canvas;
      },*/
      getMesStr(int_mes) {
        let meses = [
          'ENERO',
          'FEBRERO',
          'MARZO',
          'ABRIL',
          'MAYO',
          'JUNIO',
          'JULIO',
          'AGOSTO',
          'SEPTIEMBRE',
          'OCTUBRE',
          'NOVIEMBRE',
          'DICIEMBRE',
        ];
        return meses[int_mes - 1];
      },

      cargarDatosCanvas(certificado, estudiante) {
        window.console.log('MY CERT>>>>', this.programita, this.is_only_nombres);

        /*if (this.programita.id == 200) {
          this.cargarDatosCanvasCustom200(certificado, estudiante);
          return;
        } else if (this.programita.id == 1544 || this.programita.id == 1543) {
          this.cargarDatosCanvasOnlyEstudent1544(certificado, estudiante);
          return;
        } else if (this.is_formacion_continua_esam) {
          this.cargarDatosCanvasCustom119(certificado, estudiante);
          return;
        } else if (this.is_only_nombresv2) {
          this.cargarDatosCanvasOnlyEstudentV2(certificado, estudiante);
          return;
        } else if (this.is_only_nombres) {
          this.cargarDatosCanvasOnlyEstudent(certificado, estudiante);
          return;
        }*/
        certificado.lugar = certificado.lugar.replace('DE LA SIERRA', '');
        // certificado.curso = certificado.curso.replace('CURSO DE ', '');
        certificado.curso = certificado.curso.replace('CURSO EN ', '');
        // certificado.curso = certificado.curso.replace('CURSO ', '');
        certificado.curso = certificado.curso.replace('ESAM CURSOS', '');
        certificado.curso = certificado.curso.replace(
          'CURSOS DE FORMACIÓN CONTINUA CURSOS DE FORMACIÓN CONTINUA',
          'CURSO ',
        );
        if(certificado.curso == " EN DISEÑO DE UNIDADES CRITICAS EN HOSPITALES"){
          certificado.curso = "DISEÑO DE UNIDADES CRÍTICAS EN HOSPITALES";
        }
        //window.console.log('certificado',certificado);
        certificado.curso = certificado.curso.replace('CURSOS DE FORMACIÓN CONTINUA', '');
        var canvas = document.getElementById('myCanvas3').cloneNode(true);

        canvas.width = 1280;
        canvas.height = 908;
        canvas.style.width = '1280px';
        canvas.style.height = '908px';
        var context = canvas.getContext('2d');

        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(this.image, 0, 0, 1280, 908);

        context.font = '10px Arial';
        context.fillText('verificador:', 320, 766);
        context.fillText('estudiante:', 1175, 766);

        context.drawImage(estudiante.qr1, 285, 770, this.tam, this.tam);
        context.drawImage(estudiante.qr2, 1140, 770, this.tam, this.tam);

        context.fillStyle = '#eeffff';
        context.font = '14px Arial';
        context.fillText('000000000' + certificado.nro, canvas.width / 2 + 525, 25);
        context.fillStyle = '#000000';

        var times = certificado.fecha_registro.split('T')[0];
        var fecha = times;
        var ps = fecha.split('-');
        var dia = ps[2];
        var mes = ps[1];
        var anio = ps[0];
        var messtr = this.parseMes(mes);
        dia = parseInt(dia);
        if (this.programita.id == 1702) {
          dia = '6';
        }else if (this.programita.id == 3338) {
          dia = '13, 15, 20, 22, 27, 29';
          messtr = "JULIO";
        }

        context.font = '30px xfuente';
        context.textAlign = 'center';
        // window.console.log('certificado:::',this.is_formacion_continua,'jejeej');
        window.console.log('certificado:::>?',estudiante.nombres.length);
        if (estudiante.nombres.length >= 50) {
          context.font = '25px xfuente';
          context.fillText('' + estudiante.nombres, canvas.width / 2 + 150, 470);
        } else if (estudiante.nombres.length > 38) {
          context.font = '28px xfuente';
          context.fillText('' + estudiante.nombres, canvas.width / 2 + 150, 470);
        } else if (this.is_formacion_continua) context.fillText('' + estudiante.nombres, canvas.width / 2 + 150, 470);
        else context.fillText('' + estudiante.nombres, canvas.width / 2 + 150, 470);

        if (!this.is_formacion_continua) {
          var pp = certificado.curso;
          window.console.log('sdsdsdsds jejejeje', 54,pp.length,this.programita);
          let cut = 60;
          if(this.programita.id==3493) cut = 55; 
          if(this.programita.id==4323) cut = 55; 

          window.console.log('pp.length>>>',pp.length);
          

          if (pp.length >= 120) {
            pp = this.wordWrapToStringList(pp, 72);
            let tt = 563;
            //var vue = this;
            // window.console.log('<><><>',pp);
            if(pp.length > 2) tt = 542;
            pp.forEach(function (e) { 
               context.font = '300 20px xfuente';
              context.fillText('' + e, canvas.width / 2 + 120, tt);
              tt += 23;
            });
          }else if (pp.length >= 100) {
            pp = this.wordWrapToStringList(pp, 65);
            let tt = 563;
            //var vue = this;
            // window.console.log('<><><>',pp);
            if(pp.length > 2) tt = 542;
            pp.forEach(function (e) { 
               context.font = '300 23px xfuente';
              context.fillText('' + e, canvas.width / 2 + 120, tt);
              tt += 23;
            });
          }else if (pp.length >= cut) {
            pp = this.wordWrapToStringList(pp, 57);
            let tt = 555;
            //var vue = this;
            pp.forEach(function (e) { 
               context.font = '300 25px xfuente';
              context.fillText('' + e, canvas.width / 2 + 120, tt);
              tt += 24;
            });
          } else if (pp.length >= 54) {
            pp = this.wordWrapToStringList(pp, 54);
            let tt = 565;
            //var vue = this;
            pp.forEach(function (e) { 
               context.font = '300 25px xfuente';
              context.fillText('' + e, canvas.width / 2 + 150, tt);
              tt += 23;
            });
          } else {
            context.font = '300 28px xfuente';
            if (pp.length >= 49) context.font = '300 25px xfuente';
            context.fillText('' + pp, canvas.width / 2 + 140, 588);
          }

          context.font = '300 23px xfuente';
          context.fillText('' + certificado.carga_horaria, canvas.width / 2 + 200, 640);
          if (certificado.lugar.length > 12) {
            context.font = '300 19px xfuente';
            context.fillText('' + certificado.lugar, canvas.width / 2 + 95, 680);
          } else {
            context.fillText('' + certificado.lugar, canvas.width / 2 + 80, 680);
          }

          if(this.fecha_emision){
            window.console.log('>>>>', this.fecha_emision);
            const fs = this.fecha_emision.split('-');
            dia = fs[2]
            messtr = this.parseMes(fs[1]);
            anio = fs[0];
          } 

          context.font = '300 23px xfuente';
          context.fillText('' + dia, canvas.width / 2 + 390, 682);
          context.fillText('' + messtr, canvas.width / 2 + 90, 718);
          context.fillText('' + anio, canvas.width / 2 + 430, 718);
        }

        estudiante.canvas = canvas;
      },
      cargarDatosCanvasESAM(certificado, estudiante) {
        window.console.log('>>> jejejejej esam 1110', this.programita);
        /*if (this.is_curso_trans_dig) {
          this.cargarDatosCanvasCursoTransDig(certificado, estudiante);
          return;
        } else if (this.programita.id == 2804) {
          // por si acaso, sino borrarlo nomas
          this.cargarDatosCanvasESAM_2804(certificado, estudiante);
          return;
        }*/

        certificado.lugar = certificado.lugar.replace('DE LA SIERRA', '');
        certificado.curso = certificado.curso.replace('CURSO EN ', '');
        // certificado.curso = certificado.curso.replace('CURSO ', '');
        certificado.curso = certificado.curso.replace(
          'CURSOS DE FORMACIÓN CONTINUA CURSOS DE FORMACIÓN CONTINUA',
          'CURSO ',
        );
        certificado.curso = certificado.curso.replace('CURSOS DE FORMACIÓN CONTINUA', '');
        certificado.curso = certificado.curso.replace('CURSOS DE CAPACITACIÓN', '');
        var canvas = document.getElementById('myCanvas3').cloneNode(true);
        canvas.width = 1280;
        canvas.height = 908;
        canvas.style.width = '1280px';
        canvas.style.height = '908px';
        var context = canvas.getContext('2d');

        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(this.image, 0, 0, 1280, 908);

        context.font = '10px Arial';
        context.fillText('verificador:', 120, 745);
        context.drawImage(estudiante.qr1, 90, 748, this.tam, this.tam);
        if (this.is_formacion_continua) {
          context.drawImage(estudiante.qr2, 1075, 748, this.tam, this.tam);
          context.fillText('estudiante:', 1105, 755);
        } else {
          context.drawImage(estudiante.qr2, 1065, 748, this.tam, this.tam);
          context.fillText('estudiante:', 1095, 745);
        }

        context.fillStyle = '#eeffff';
        context.font = '200 14px xfuente';
        if (this.programita.id == 693 || this.programita.id == 704) {
          context.fillText('000000000' + certificado.nro, canvas.width / 2 + 505, 55);
        } else {
          context.fillText('000000000' + certificado.nro, canvas.width / 2 + 505, 55);
        }
        context.fillStyle = '#000000';

        var times = certificado.fecha_registro.split('T')[0];
        var fecha = times;
        var ps = fecha.split('-');
        var dia = ps[2];
        var mes = ps[1];
        var anio = ps[0];
        var messtr = this.parseMes(mes);
        dia = parseInt(dia);

        context.font = '200 30px xfuente';
        context.textAlign = 'center';
        //window.console.log( 'HOLA MUNDO:::::::',this.is_fc_id854 );

        if (this.is_fc_id498) {
          context.fillText('' + estudiante.nombres, canvas.width / 2 + 0, 395);
        } else if (this.is_formacion_continua) context.fillText('' + estudiante.nombres, canvas.width / 2 + 0, 505);
        else context.fillText('' + estudiante.nombres, canvas.width / 2 + 50, 505);

        if (!this.is_formacion_continua) {
          var pp = certificado.curso;
          let tam = certificado.curso.length;
          //window.console.log('>',pp.length)
          let cut = 65;
          if(this.programita.id==3956) cut = 65;

          if (pp.length > cut) {
            pp = this.wordWrapToStringList(pp, cut);
            var tt = 585;
            //var vue = this;
            pp.forEach(function (e) {
              if (tam > 100) context.font = '200 20px xfuente';
              else context.font = '200 23px xfuente';
              context.fillText('' + e, canvas.width / 2 + 50, tt);
              tt += 22;
            });
          } else if (this.programita.id == 1990) {
            context.font = '200 25px xfuente';
            context.fillText('' + pp, canvas.width / 2, 595);
          } else {
            context.font = '200 30px xfuente';
            context.fillText('' + pp, canvas.width / 2 + 50, 595);
          }
          context.font = '200 23px xfuente';
          context.fillText('' + certificado.carga_horaria, canvas.width / 2 - 20, 640);
          context.fillText('' + certificado.lugar, canvas.width / 2 - 100, 678);
          
          // 
          if(this.programita.id == 5617){
            dia = '31';
            messtr = 'ENERO';
          } 
          
          
          
          context.fillText('' + dia, canvas.width / 2 + 190, 678);
          context.fillText('' + messtr, canvas.width / 2 - 90, 710);
          context.fillText('' + anio, canvas.width / 2 + 220, 710);
          
        }

        estudiante.canvas = canvas;
      },
      /*cargarDatosCanvasESAM_2804(certificado, estudiante) {
        var canvas = document.getElementById('myCanvas3').cloneNode(true);
        canvas.width = 1280;
        canvas.height = 908;
        canvas.style.width = '1280px';
        canvas.style.height = '908px';
        var context = canvas.getContext('2d');

        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(this.image, 0, 0, 1280, 908);

        context.font = '10px Arial';
        context.fillText('verificador:', 1125, 45);
        context.drawImage(estudiante.qr1, 1090, 48, this.tam, this.tam);

        context.fillStyle = '#eeffff';
        context.font = '200 14px xfuente';
        context.fillText('000000000' + certificado.nro, 30, 25);
        context.fillStyle = '#000000';

        let nombre = certificado.curso;
        if (this.postitulo && this.postitulo.postitulo) {
          nombre = this.postitulo.postitulo;
        }
        certificado.curso = nombre.toUpperCase();

        var times = certificado.fecha_registro.split('T')[0];
        var fecha = times;
        var ps = fecha.split('-');
        var dia = ps[2];
        var mes = ps[1];
        var anio = ps[0];
        var messtr = this.parseMes(mes);
        dia = parseInt(dia);

        context.font = '200 30px xfuente';
        context.textAlign = 'center';
        context.fillText('' + estudiante.nombres, canvas.width / 2 + 50, 360);
        var pp = certificado.curso;
        if (pp.length > 65) {
          pp = this.wordWrapToStringList(pp, 65);
          var tt = 485;
          pp.forEach(function (e) {
            context.font = '200 23px xfuente';
            context.fillText('' + e, canvas.width / 2 + 50, tt);
            tt += 22;
          });
        } else {
          context.font = '200 30px xfuente';
          context.fillText('' + pp, canvas.width / 2 + 50, 495);
        }
        context.font = '200 20px xfuente';
        context.fillText('' + certificado.carga_horaria, canvas.width / 2 + 50, 555);
        context.fillText('' + certificado.lugar, canvas.width / 2 + 40, 610);
        context.fillText('' + dia, canvas.width / 2 + 360, 610);
        context.fillText('' + messtr, canvas.width / 2 + 40, 645);
        context.fillText('' + anio, canvas.width / 2 + 370, 645);

        estudiante.canvas = canvas;
      },*/

      obtenerMesEnEspanol(mes) {
          const meses = [
              'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
              'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
          ];
          return meses[mes];
      },

      cargarDatosCanvasCCA(certificado, estudiante) {
        /* let a = 1;
        if (2 > a) {
          this.cargarDatosCanvasCCA_UAJMS(certificado, estudiante);
          return;
        } */
        window.console.log('>>>>>>>>>>> cca certificado', this.programa);
        var canvas = document.getElementById('myCanvas3').cloneNode(true);
        canvas.width = 1280;
        canvas.height = 908;
        canvas.style.width = '1280px';
        canvas.style.height = '908px';
        var context = canvas.getContext('2d');

        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(this.image, 0, 0, 1280, 908);

        let dateInicio = new Date(this.programa.fecha_inicio+'T00:00:00-04:00');
        let dateFin = new Date(this.programa.fecha_fin+'T00:00:00-04:00');
        if(!dateInicio || !dateFin){
          this.$root.$notify.show(`falta la fecha de inicio o fin del curso`, { color: 'red' });
          return;
        }
        const diaInicio = dateInicio.getDate();
        const mesInicioEspanol = this.obtenerMesEnEspanol(dateInicio.getMonth());
        const anioInicio = dateInicio.getFullYear();

        const diaFin = dateFin.getDate();
        const mesFinEspanol = this.obtenerMesEnEspanol(dateFin.getMonth());
        const anioFin = dateFin.getFullYear();

        window.console.log(diaInicio,mesInicioEspanol,anioInicio);
        window.console.log(diaFin,mesFinEspanol,anioFin);

        context.font = '10px Arial';
        /*context.fillText("verificador:", 320, 755);
      context.drawImage(estudiante.qr1, 285, 758, this.tam, this.tam);
      context.fillText("estudiante:", 1095, 755);
      context.drawImage(estudiante.qr2, 1065, 758, this.tam, this.tam);*/

        context.fillText('verificador:', 320, 766);
        context.fillText('estudiante:', 1175, 766);

        context.drawImage(estudiante.qr1, 285, 770, this.tam, this.tam);
        context.drawImage(estudiante.qr2, 1140, 770, this.tam, this.tam);

        context.fillStyle = '#eeffff';
        context.font = '200 14px xfuente';
        context.fillText('0000' + certificado.nro, canvas.width / 2 + 515, 25);
        context.fillStyle = '#000000';

        var times = certificado.fecha_registro.split('T')[0];
        var fecha = times;
        var ps = fecha.split('-');
        var dia = ps[2];
        var mes = ps[1];
        var anio = ps[0];
        var messtr = this.parseMes(mes);
        dia = parseInt(dia);

        context.font = '200 30px xfuente';
        context.textAlign = 'center';
        context.fillText('' + estudiante.nombres, canvas.width / 2 + 100, 475);
        var pp = certificado.curso;
        if (pp.length >= 52) {
          pp = this.wordWrapToStringList(pp, 52);
          var tt = 565;
          //var vue = this;
          pp.forEach(function (e) {
            context.font = '200 23px xfuente';
            context.fillText('' + e, canvas.width / 2 + 110, tt);
            tt += 22;
          });
        } else {
          context.font = '200 28px xfuente';
          context.fillText('' + pp, canvas.width / 2+100, 588);
        }
        context.font = '200 22px xfuente';
        context.fillText('' + certificado.carga_horaria, canvas.width / 2 +129, 642);

        context.fillText('' + diaInicio, canvas.width / 2 - 150, 693);
        context.fillText('' + mesInicioEspanol, canvas.width / 2 - 37, 693);
        context.fillText('' + anioInicio, canvas.width / 2 + 100, 693);
        context.fillText('' + diaFin, canvas.width / 2 + 180, 693);
        context.fillText('' + mesFinEspanol, canvas.width / 2 + 300, 693);
        context.fillText('' + anioFin, canvas.width / 2 + 450, 693);
 
        context.font = '200 21px xfuente';
        context.fillText('' + certificado.lugar, canvas.width / 2 + 165, 754);
        context.fillText('' + dia, canvas.width / 2 + 248, 754);
        context.fillText('' + messtr, canvas.width / 2 + 350, 754);
        context.fillText('' + anio, canvas.width / 2 + 520, 754);

        estudiante.canvas = canvas;
      },

      listarEstudiantes() {
        this.estudiantes = [];
        //this.$refs.c_alertar.cargando();
        this.loading = true;
        var vue = this;
        var sql = gql`query{ getPrograma(id:${this.idprograma}){arte,fecha_inicio,fecha_fin,postgrado{categoria{nombre},nombre,carga_horaria},universidad{nombre,convenio,id},sede{id,nombre,ciudad{nombre}},inscripciones{certificado_id,id,estado_ins,fecha_registro,asesor{id},estudiante{email,num_doc,telefono1,usuario_moodle,clave_moodle,nombres,pri_apellido,seg_apellido,departamento{extension},estado,grados{id nombre abreviatura titulo nivel}},asesor{num_doc,num_doc,nombres,pri_apellido,seg_apellido}}}}`;

        this.$apollo
          .query({
            query: sql,
          })
          .then((data) => {
            var participantes = [];
            var res = data.data.getPrograma;
            this.result = res;

            res.inscripciones.forEach(function (e) {
              var est = e.estudiante;
              var am = est.seg_apellido;
              if (!am) am = '';
              var nom = est.nombres + ' ' + est.pri_apellido + ' ' + am;
              var estado = 0;
              if (e.certificado_id) estado = 2;
              var estudiante = {
                id_ins: e.id,
                nombres: nom.toUpperCase(),
                num_doc: est.num_doc,
                email: est.email,
                check: e.estado_ins > 0,
                certificado_id: e.certificado_id,
                estado_ins: e.estado_ins,
                telefono1: est.telefono1,
                estado: estado,
                grados: vue.sortGrados(est.grados),
                qr1: null,
                qr2: null,
                sindeuda: false, //solo genera cert. los que no tengan deuda
                title: '',
              };

              if (vue.mostrarGrado) {
                if (estudiante.grados[0]) {
                  estudiante.nombres = estudiante.grados[0].abreviatura + ' ' + estudiante.nombres;
                  estudiante.nombres = estudiante.nombres.toUpperCase();
                }
              }
              participantes.push(estudiante);
              if (e.certificado_id) vue.getCertificado(e.certificado_id);
            });

            var fondo_certificado = res.arte;
            if (fondo_certificado) {
              fondo_certificado = process.env.VUE_APP_URL_CERT_PROGRAMAS + res.arte;
              window.console.log('IMG ARTE:', fondo_certificado);
              if (
                fondo_certificado.endsWith('.jpg') ||
                fondo_certificado.endsWith('.jpeg') ||
                fondo_certificado.endsWith('.png')
              )
                // el servidor crea por defecto co esta extesion
                this.cargarFondoCertificado(fondo_certificado);
            }

            participantes.sort(function (a, b) {
              return b.estado_ins - a.estado_ins;
            });
            this.estudiantes = participantes;
            this.descargartodo = true;
            //this.$refs.c_alertar.reset();
            this.loading = false;
            this.idsede = res.sede.id;
            this.isSedePermitida(this.idsede);
            //window.console.log('Verificar deuda:::',this.$store.state.CARGO);
            if (this.$store.state.CARGO.sede.unidad_negocio == 1) {
              this.verificardeudas();
            } else {
              this.estudiantes.map((x) => {
                x.sindeuda = true;
              });
            }
          })
          .catch((error) => {
            // window.console.error(error);
            //vue.$refs.c_alertar.reset();
            vue.loading = false;
            vue.$notify(parseJsonError(error, 'getPrograma'));
          });
      },
      sortGrados(grados) {
        if (!grados) return [];
        grados = grados.sort(function (a, b) {
          return a.nivel - b.nivel;
        });
        return grados;
      },
      verificardeudas() {
        this.loading = true;
        const vue = this;
        let inscritos = this.estudiantes.filter((x) => x.estado_ins == 1);
        let unidad = this.$store.state.CARGO.sede.unidad_negocio;
        let peticiones = [];
        let urlc = `${process.env.VUE_APP_API_REST}/api/pagos/conceptos/buscar`;
        //let urlc = `http://localhost:8090/api/pagos/conceptos/buscar`;
        let raw = JSON.stringify({ unidad_negocio_id: unidad });
        peticiones.push(xaxios.post(urlc, raw));

        inscritos.forEach((x) => {
          const url5 = `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/${x.id_ins}/plan-pago/kardex`;
          peticiones.push(xaxios.get(url5).then((r) => ({ name: `${x.id_ins}`, result: r })));
        });

        //window.console.log(this.estudiantes)

        Promise.all(peticiones)
          .then((values) => {
            window.console.log('values[0].data::', values[0].data);
            let muestra = values[0].data.filter((c) => c.muestra_asignacion == true && c.opcional == true);
            muestra = muestra.map((m) => {
              return m.id;
            });
            window.console.log('muestradata::', muestra);
            if(muestra.length == 0){
              this.estudiantes.map((x) => {
                x.sindeuda = true;
              });
            }
            for (let i = 1; i < values.length; i++) {
              if (!values[i]) values[i] = { result: { data: { data: [] } } };

              let cuotas = values[i].result.data.data;
              let xsaldo = 0;
              cuotas.forEach((c) => {
                if (muestra.includes(c.concepto_pago_id)) {
                  xsaldo += c.saldo;
                }
              });
              let est = vue.estudiantes.find((e) => e.id_ins == values[i].name); 
              if (xsaldo == 0) est.sindeuda = true;
              else {
                window.console.log('xsaldoxsaldoxsaldo',xsaldo);
                
                est.check = false;
                est.title = `Este estudiante tiene una saldo pendiente de ${xsaldo} Bs.`;
              }

              //window.console.log(values[i].name,xsaldo);
              vue.loading = false;
              /*vue.estudiantes.sort(function(a, b){
                let f = 0;
                if( a.estado_ins < b.estado_ins ) f = -1;
                if( a.sindeuda ) f = -1;
                return f;
          });*/
            }
              vue.loading = false;
          })
          .catch((e) => {
            window.console.error(e);
            vue.loading = false;
          });
      },

      iniciarGeneracion() {
        var vue = this;
        var tam = this.estudiantes.length;
        let datos = {};
        datos.estudiantes = [];

        this.estudiantes.forEach(function (e) {
          if (e.check) {
            if (e.certificado_id) {
              tam = tam - 1;
              vue.getCertificado(e.certificado_id);
            } else if (e.estado_ins > 0) {
              let programa = vue.result;
              e.estado = 1;
              let nombre = programa.postgrado.nombre;
              nombre = nombre.replace(programa.postgrado.categoria.nombre, '').replace('- ', '');

              if (vue.postitulo && vue.postitulo.postitulo) {
                nombre = vue.postitulo.postitulo;
              }
              datos.curso = nombre.toUpperCase();
              if (programa.universidad) datos.emisor = programa.universidad.nombre.toUpperCase();
              else {
                datos.emisor = 'Sin emisor';
              }
              datos.lugar = programa.sede.ciudad.nombre.toUpperCase();
              if (datos.lugar == 'CAMARGO') datos.lugar = 'TARIJA';

              //datos.curso = "TÉCNICAS Y HERRAMIENTAS DE CONCILIACIÓN CIVIL, FAMILIAR Y PENAL";
              //programa.postgrado.carga_horaria = 200;

              if (vue.postitulo) datos.carga_horaria = vue.postitulo.horas_academicas;
              else datos.carga_horaria = programa.postgrado.carga_horaria;
              datos.fecha_inicio = programa.fecha_inicio;
              datos.fecha_fin = programa.fecha_fin;
              datos.imagen_fondo = programa.arte;
              if (!datos.imagen_fondo) datos.imagen_fondo = 'img/certsigloxxx.jpg';
              //datos.estudiantes = [];
              datos.estudiantes.push({ inscripcion_id: e.id_ins, estudiante: e.nombres });

              // vue.generarCertificados( e,vue.result,tam,index );
            }
          }
        });

        vue.generarCertificados(datos, vue.result);
      },

      generarCertificadospre(estudiante, programa) {
        window.console.log('programaprogramaprograma',this.programita);
        estudiante.estado = 1;
        let datos = {},
          nombre = programa.postgrado.nombre;
        nombre = nombre.replace(programa.postgrado.categoria.nombre, '').replace('- ', '');
        if (this.postitulo && this.postitulo.postitulo) {
          nombre = this.postitulo.postitulo;
        }
        datos.curso = nombre.toUpperCase() + ''.trim();
        if(this.programita.id == 4484) datos.curso = "REGLAMENTO DE SERVICIO PÚBLICO DE SUMINISTRO DE ELECTRICIDAD Y REGLAMENTO PARA EL USO DE BIENES DE DOMINIO PÚBLICO Y CONSTITUCIÓN DE SERVIDUMBRE";

        if (programa.universidad) datos.emisor = programa.universidad.nombre.toUpperCase();
        else {
          datos.emisor = 'Sin emisor';
        }
        datos.lugar = programa.sede.ciudad.nombre.toUpperCase();
        if (datos.lugar == 'CAMARGO') datos.lugar = 'TARIJA';

        //datos.curso = "TÉCNICAS Y HERRAMIENTAS DE CONCILIACIÓN CIVIL, FAMILIAR Y PENAL";
        //programa.postgrado.carga_horaria = 200;

        if (this.postitulo) datos.carga_horaria = this.postitulo.horas_academicas;
        else datos.carga_horaria = programa.postgrado.carga_horaria;
        datos.fecha_inicio = programa.fecha_inicio;
        datos.fecha_fin = programa.fecha_fin;
        datos.imagen_fondo = programa.arte;
        if (!datos.imagen_fondo) datos.imagen_fondo = 'img/certsigloxxx.jpg';
        // if (this.image.src) datos.imagen_fondo = this.image.src;
        //window.console.log('this.image.src> ', datos);
        datos.estudiantes = [];
        datos.estudiantes.push({ inscripcion_id: estudiante.id_ins, estudiante: estudiante.nombres });
        this.generarCertificados(datos);
      },

      generarCertificados(datos) {
        const vue = this;
        var sql = gql`mutation{ generarCertificados(input:${window.stringifyObject(
          datos,
        )}){ ok certificados{inscripcion_id id codigo nro} errors{message} } }`;

        this.$apollo
          .query({
            query: sql,
          })
          .then((data) => {
            var res = data.data.generarCertificados;
            if (!res.certificados) res.certificados = [];
            //window.console.log( '>>>>>>>>>>>>>>>',res );
            res.certificados.forEach(function (e) {
              var cer = e;
              var est = vue.estudiantes.find((x) => x.id_ins == cer.inscripcion_id);
              if (est) {
                est.certificado_id = cer.id;
                est.estado = 2;
                vue.getCertificado(cer.id);
              }
              vue.cetificados_uids.push(cer);
            });
            vue.descargartodo = true;
          })
          .catch((error) => {
            vue.msg = error;
            // estudiante.estado = 1010;
            // window.console.error(error)
          });
      },
      getCertificado(id_cert) {
        var sql = gql`query{ getCertificadoById(id:${id_cert}){id codigo nro curso estudiante emisor lugar carga_horaria fecha_inicio fecha_fin fecha_registro imagen_fondo estado} }`;
        this.$apollo
          .query({
            query: sql,
          })
          .then((data) => {
            var res = data.data.getCertificadoById;
            // window.console.log( '::::::::::::::::::::::::::::::::::::::',res );
            //this.cetificados_uids.push( res )
            if (res) {
              //window.console.log( "ID CERTIFICADOS: ",id_cert,'\n',res )
              this.certificados.push(res);
              var est = this.estudiantes.find((x) => x.certificado_id == id_cert);
              est.nombres = res.estudiante;
            }
          })
          .catch((error) => {
            this.msg = error;
            // window.console.error(error)
          });
      },
      /** ANULAR CERTIFICADO GENERADO */
      preAnularcertificado(estudiante) {
        var vue = this;
        var opt = {
          verification: 'anular',
          verificationHelp: 'Escriba "[+:verification]" para anular este certificado.',
          okText: 'Anular certificado',
          cancelText: 'cancelar',
          backdropClose: false,
          animation: 'bounce',
          loader: true,
          type: 'hard',
        };
        var message = {
          title: 'Confirmar anulacion',
          body: '<br> <b>NOTA:</b> Al anular el certificado se genera un nuevo numero de cetificado y se establece la fecha de hoy.',
        };
        this.$dialog
          .confirm(message, opt)
          .then(function (dialog) {
            vue.anularCertificado(estudiante, dialog);
          })
          .catch(function () {});
        return;
      },
      anularCertificado(estudiante, dialog) {
        var sql = gql`mutation{ cambiarEstadoCertificado(input:{ id:${estudiante.id_ins} estado: false }){ ok certificado{id inscripcion_id codigo nro} errors{message} } }`;
        this.$apollo
          .mutate({
            mutation: sql,
          })
          .then((data) => {
            var datos = data.data.cambiarEstadoCertificado;
            if (datos.ok) {
              //estudiante.certificado_id = null;
              estudiante.estado = 0;
              this.anularPdfExiste(estudiante);
            }
            dialog.close();
          })
          .catch((error) => {
            this.msg = error;
            // window.console.error(error)
          });
      },
      /** FIN ANULAR CERTIFICADO */

      descargarTodos() {
        this.mensaje = '';
        var vue = this;
        var descargados = 0;
        var nodescargados = 0;
        this.estudiantes.forEach(function (e) {
          if (e.estado_ins > 0 && e.certificado_id) {
            if (e.check) {
              descargados += 1;
              vue.decargar(e, true);
            } else {
              nodescargados += 1;
            }
          } else {
            nodescargados += 1;
          }
        });
        this.mensaje =
          'REPORTE: ' +
          descargados +
          ' Generados, ' +
          nodescargados +
          ' No Generados. \nRecuerde que los participantes deben tener un certificado generado para usar esta funcionalidad.';
      },
      decargar(estudiante, savePDF) {
        //window.console.log("-------------------descargarrr");
        var cer = this.certificados.find((x) => x.id == estudiante.certificado_id);
        if (cer) {
          //window.console.log( 'VISTA:::',cer )
          estudiante.estado = 3;
          this.mensajito = 'Cargando vista previa...';

          if (estudiante.qr1 && estudiante.qr2 && estudiante.canvas && !this.postitulo) {
            if (savePDF) this.guardar(estudiante);
            else {
              estudiante.estado = 2;
              var vue = this;
              //window.console.log("jajajaja");
              setTimeout(() => {
                vue.previewCertificado(estudiante);
              }, 350);
            }
          } else {
            this.cargarQRleft(cer.codigo, estudiante);
            this.cargarQRRight(estudiante);
            setTimeout(() => {
              //if( !this.programita.universidad ) this.programita.universidad = {};
              window.console.log('Hola mundo.....', this.programita, this.postitulo);
              let ispostitulo9 = false;
              let idpostitulouni = -1;
              let ispostitulo52esam = false;
              if (this.postitulo) {
                ispostitulo52esam = this.postitulo.universidad == 52;
                ispostitulo9 = this.postitulo.universidad == 9;
                idpostitulouni = this.postitulo.universidad;
              }
              if (!this.programita.universidad) this.programita.universidad = { id: 9 }; // no esta bien pero funciona

              if (
                this.programita.sede.nombre.toLowerCase().includes('cca') ||
                this.programita.sede.nombre.toLowerCase().includes('ciberkids')
              )
                this.cargarDatosCanvasCCA(cer, estudiante);
              else if (this.programita.universidad.id == 2 || idpostitulouni == 2)
                this.cargarDatosCanvasCCA(cer, estudiante);
                // this.cargarDatosCanvasUAJMS(cer, estudiante);
              else if (ispostitulo52esam) this.cargarDatosCanvasESAM(cer, estudiante);
              else if (this.programita.universidad.id == 9 || this.programita.universidad.id == 49 || ispostitulo9) this.cargarDatosCanvas(cer, estudiante);
              else this.cargarDatosCanvasESAM(cer, estudiante);
              if (savePDF) this.guardar(estudiante);
              else {
                estudiante.estado = 2;
                this.previewCertificado(estudiante);
              }
            }, 1500);
          }
        } else {
          window.alert('No hay certificado: ' + estudiante.nombres);
        }
      },
      guardar(estudiante) {
        let width = estudiante.canvas.width;
        let height = estudiante.canvas.height;
        var pdf;

        if (width > height) {
          pdf = new window.jsPDF('l', 'px', [width, height]);
        } else {
          pdf = new window.jsPDF('p', 'px', [height, width]);
        }

        width = pdf.internal.pageSize.getWidth();
        height = pdf.internal.pageSize.getHeight();
        pdf.addImage(estudiante.canvas, 'PNG', 0, 0, width, height);
        pdf.save(estudiante.nombres + '.pdf');
        estudiante.estado = 2;
      },

      previewCertificado(estudiante) {
        var modalsize = document.getElementById('content-preview').getBoundingClientRect();
        var a = ((modalsize.width - 30) * 100) / estudiante.canvas.width / 100;
        var destinationCanvas = document.getElementById('myCanvasview');
        var destCtx = destinationCanvas.getContext('2d');
        destinationCanvas.width = estudiante.canvas.width;
        destinationCanvas.height = estudiante.canvas.height / 2;
        destCtx.scale(a, 0.4);
        destCtx.drawImage(estudiante.canvas, 0, 0);
        this.mensajito = '';
      },

      generarParaCorreos() {
        this.mensaje = '';
        var vue = this;
        vue.correos = [];
        var inscritos = [];
        var descargados = 0;
        var nodescargados = 0;

        this.estudiantes.forEach(function (e) {
          if (e.estado_ins > 0 && e.certificado_id) {
            if (e.check) {
              descargados += 1;
              inscritos.push(e);
            } else {
              nodescargados += 1;
            }
          } else {
            nodescargados += 1;
          }
        });

        var tam = inscritos.length;
        inscritos.forEach(function (e, index) {
          vue.alistarPdfServer(e, tam, index);
        });

        this.mensaje =
          'REPORTE: ' +
          descargados +
          ' Generados, ' +
          nodescargados +
          ' No Generados. \nRecuerde que los participantes deben tener un certificado generado para usar esta funcionalidad.';
      },
      enviarPorWhatsapp(estudiante) {
        this.alistarUnPdfServer(estudiante, 0, 1); // para no mostrar el modal de correo
        if (!estudiante.telefono1) {
          window.alert('Este estudiante no tiene numero de telefono.');
          return;
        }
        var filepdf = this.generarNombrePdf(estudiante);
        var link = process.env.VUE_APP_URL_CERTIFICADOS + filepdf;
        var ppr = this.programita.postgrado.categoria.nombre + ' ' + this.pro;
        ppr = ppr.replace('CURSOS DE FORMACIÓN CONTINUA CURSOS DE FORMACIÓN CONTINUA', 'CURSO ');
        ppr = ppr.toUpperCase();
        var txt =
          'Hola ' +
          estudiante.nombres +
          ', *ESAM* le saluda y le felicita por tener a la institución como la primera opción para continuar con su desarrollo personal y  profesional, por este medio le envío el enlace de su certificado del: \n*' +
          ppr +
          '* para que pueda descargarlo en formado PDF. \n\nAnte cualquier duda o consulta, no dude en contactarme por este medio, a fin de guiarle u orientarle. \n\n' +
          link;
        txt = encodeURIComponent(txt);
        //window.open( `${process.env.VUE_APP_API_WHATSAPP}591${estudiante.telefono1}&text=${txt}`);
        window.open(`${process.env.VUE_APP_API_WHATSAPP}${estudiante.telefono1}&text=${txt}`); // el codigo de pais debe
      },
      alistarUnPdfServer(estudiante, tam, index) {
        this.correos = [];
        this.alistarPdfServer(estudiante, tam, index);
      },
      alistarPdfServer(estudiante, tam, index) {
        var cer = this.certificados.find((x) => x.id == estudiante.certificado_id);
        if (cer) {
          estudiante.estado = 3;

          if (estudiante.qr1 && estudiante.qr2 && estudiante.canvas) {
            this.verificarPdfExiste(estudiante, tam, index);
          } else {
            this.cargarQRleft(cer.codigo, estudiante);
            this.cargarQRRight(estudiante);
            setTimeout(() => {
              // if( this.programita.sede.nombre.toLowerCase().includes("cca") || this.programita.sede.nombre.toLowerCase().includes("ciberkids"))
              //  this.cargarDatosCanvasCCA( cer,estudiante );
              if (this.programita.universidad.id == 9) this.cargarDatosCanvas(cer, estudiante);
              else this.cargarDatosCanvasESAM(cer, estudiante);
              this.verificarPdfExiste(estudiante, tam, index);
            }, 1400);
          }
        }
      },
      verificarPdfExiste(estudiante, tam, index) {
        var nombre = this.generarNombrePdf(estudiante);

        var formData = new FormData();
        formData.append('nombre', nombre);

        var vue = this;
        window.jQuery.support.cors = true;
        window.$.ajax({
          method: 'POST',
          headers: {},
          url: `${process.env.VUE_APP_URL_WEBDATA}certificado2.php`,
          data: formData,
          processData: false,
          contentType: false,
        })
          .done(function (data) {
            if (data.estado) {
              vue.armarCorreo(estudiante, data, tam, index); // momentaneamente
              //vue.subirPDF( estudiante,tam,index );
            } else {
              vue.subirPDF(estudiante, tam, index);
            }
          })
          .catch(function (e) {
            estudiante.estado = 10101; //algun error
            window.console.error(e);
          });
      },
      subirPDF(estudiante, tam, index) {
        estudiante.estado = 3;
        let width = estudiante.canvas.width;
        let height = estudiante.canvas.height;
        var pdf;
        var nombre = this.generarNombrePdf(estudiante);

        if (width > height) {
          pdf = new window.jsPDF('l', 'px', [width, height]);
        } else {
          pdf = new window.jsPDF('p', 'px', [height, width]);
        }

        width = pdf.internal.pageSize.getWidth();
        height = pdf.internal.pageSize.getHeight();
        pdf.addImage(estudiante.canvas, 'PNG', 0, 0, width, height);
        //pdf.save( nombre );

        var arc = pdf.output('blob');

        var formData = new FormData();
        formData.append('nombre', nombre);
        formData.append('file', arc);

        var vue = this;
        window.jQuery.support.cors = true;
        window.$.ajax({
          method: 'POST',
          headers: {},
          url: `${process.env.VUE_APP_URL_WEBDATA}certificados.php`,
          data: formData,
          processData: false,
          contentType: false,
        })
          .done(function (data) {
            vue.armarCorreo(estudiante, data, tam, index);
          })
          .catch(function () {
            estudiante.estado = 10101; //algun error
          });
      },
      armarCorreo(estudiante, data, tam, index) {
        estudiante.estado = 2;
        var correo = {};
        let filePdf = process.env.VUE_APP_URL_CERTIFICADOS + data.file;
        let link = `<p><a href="${filePdf}" download><b>Toca aqui para descargar tu certificado</b></a> </p>`;
        correo.xid = -1;
        correo.xtitle = 'Enviar Certificado al Estudiante';
        (correo.xbody = `Hola ${estudiante.nombres}, *${process.env.VUE_APP_NAME}* le saluda y le felicita por tener a la institución como la primera opción para continuar con su desarrollo personal y profesional.\n\n
        Por este medio le envío el enlace de su certificado de:\n ${this.pro}, \n
        para que pueda descargarlo en formato PDF.\n\n
        Ante cualquier duda o consulta, no dude en contactarme por este medio, a fin de guiarle u orientarle. \n\n ${link} \n\n
        para verificar su certificado puede urilizar la app ${process.env.VUE_APP_GOOGLE_QR_APP} y escanear el codigo del certificado`),
          (correo.xlink = link);
        correo.xestudiante = estudiante.nombres;
        var xxxxp = this.programita.postgrado.categoria.nombre + ' ' + this.pro;
        xxxxp = xxxxp.toUpperCase();
        xxxxp = xxxxp.replace('CURSOS DE FORMACIÓN CONTINUA', '');
        xxxxp = xxxxp.replace('CURSOS', 'Curso');
        correo.xpro = xxxxp;
        correo.all = false;
        correo.isDefault = true;
        correo.xsql = null;
        correo.xcorreo = estudiante.email;
        //correo.xcorreo = 'eclipseconsol@gmail.com';
        correo.xnombre = `${process.env.VUE_APP_NAME} Certificado`;
        correo.xasunto = `${process.env.VUE_APP_NAME} Certificado`;
        correo.xestado = '';
        this.correos.push(correo);

        if (tam - 1 == index) {
          this.mostrarModalCorreo();
        }
      },

      anularPdfExiste(estudiante) {
        var nombre = this.generarNombrePdf(estudiante);
        var formData = new FormData();
        formData.append('nombre', nombre);

        window.jQuery.support.cors = true;
        window.$.ajax({
          method: 'POST',
          headers: { credentials: 'false' },
          url: `${process.env.VUE_APP_URL_WEBDATA}certificadodel.php`,
          data: formData,
          processData: false,
          contentType: false,
        })
          .done(function (data) {
            estudiante.certificado_id = null;
            this.$notify(exito('Certificado Anulado', data + 'PDF?CUSTOM' + nombre));
          })
          .catch(function () {
            estudiante.certificado_id = null;
            estudiante.estado = 10101;
          });
      },

      mostrarModalCorreo() {
        window.$('#modalemail').modal('show');
      },

      generarNombrePdf(estudiante) {
        var nombre = estudiante.nombres;
        nombre = getCleanedString(nombre);
        nombre = nombre.toLowerCase() + '_' + estudiante.id_ins + '_' + estudiante.certificado_id + '.pdf';
        return nombre;
      },

      cargarFondoCertificado(img) {
        var vue = this;
        window.console.log('Cargando imagen del certificado... ', img);
        this.msgimg = 'Cargando imagen del certificado... ' + img;
        this.image.src = img;
        this.image.setAttribute('crossorigin', 'anonymous'); // evita un error que da jsPdf.js
        this.image.onload = function () {
          var canvas = document.getElementById('myCanvas3');
          var context = canvas.getContext('2d');
          context.drawImage(vue.image, 0, 0, 1280, 908);
          vue.msgimg = '';
        };
        this.image.onerror = function () {
          if (vue.is_cca) {
            vue.cargarFondoCertificado('img/cca_fondo.png'); // podria dar un bucle infinito jejejej
          }
        };
      },

      getpostitulos(programa_id) {
        window.console.log(this.api_rest);
        this.loadingpostitulos = true;
        const vue = this;
        xaxios
          .get(`${this.api_rest}/api/v1/postitulos/programaid/${programa_id}`)
          //axios.get(`http://localhost:8090/api/v1/postitulos/programaid/${programa_id}`)
          .then(function (response) {
            let data = response.data;
            data.data.forEach((x) => {
              vue.postitulos.push({
                id: x.Id,
                programa_id: x.Programa_id,
                postitulo: x.Postitulo,
                horas_academicas: x.Horas_academicas,
                universidad: x.Universidad,
                text: x.Postitulo + ` (${x.Horas_academicas}Hrs.)`,
              });
            });
            vue.postitulos.push();
            vue.loadingpostitulos = false;
          })
          .catch(function (error) {
            window.console.log(error);
            vue.loadingpostitulos = false;
          });
      },

      myFunction1(filtro) {
        filtro = filtro.toUpperCase();
        var table, tr, tdd, td, i, j, txtValue;
        table = document.getElementById('midatatable');
        tr = table.getElementsByTagName('tr');
        for (i = 0; i < tr.length; i++) {
          tdd = tr[i].getElementsByTagName('td');
          for (j = 1; j < tdd.length; j++) {
            td = tdd[j];
            if (td) {
              txtValue = td.textContent;
              if (txtValue.toUpperCase().indexOf(filtro) > -1) {
                tr[i].style.display = '';
                break;
              } else {
                tr[i].style.display = 'none';
              }
            }
          }
        }
      },
      getprogramabyid() {
        var xp = window.sessionStorage.xprograma;
        var p = JSON.parse(xp);
        let id = p.id;
        let vue = this;
        this.loading = true;

        xaxios
          .get(`${process.env.VUE_APP_API_REST}/esam/programa/id/${id}`)
          .then(async ({ data }) => {
            vue.loading = false;
            //window.console.log('PROGRMA GET:::', data);
            vue.parsedata(data);
          })
          .catch(() => {
            this.loading = false;
          });
      },
      parsedata(prog_server) {
        var xp = window.sessionStorage.xprograma;
        var vue = this;
        if (xp) {
          var p = JSON.parse(xp);
          if (p.universidad) p.universidad.id = prog_server.universidad_id;
          window.console.log('certificado programa:', p, prog_server);
          //let nombresede = p.sede.nombre.toLowerCase();
          //let iscca = false;
          //if( nombresede.includes('cca ') ) iscca = true;
          this.pro = this.parsePrograma(p);

          this.image = new Image();
          let img = process.env.VUE_APP_URL_CERT_PROGRAMAS + p.arte; // option two
          /*if( iscca ) { img = "img/cca_certificado.jpg";this.is_cca = true }
      else */
          if (p.id == 1024 || p.id == 884 || p.id == 972) this.is_curso_trans_dig = true;
          else if (p.id == 336) {
            img = 'img/fc_derecho_v1.png';
            this.is_formacion_continua = true;
          } else if (p.id == 337) {
            img = 'img/fc_derecho_v2.png';
            this.is_formacion_continua = true;
          } else if (p.id == 332) {
            img = 'img/fc_docente_v2.png';
            this.is_formacion_continua = true;
          } else if (p.id == 333) {
            img = 'img/fc_docente_v3.png';
            this.is_formacion_continua = true;
          } else if (p.id == 331) {
            img = 'img/fc_teletrabajo_v1.png';
            this.is_formacion_continua = true;
          } else if (p.id == 334) {
            img = 'img/fc_comercio_v2.png';
            this.is_formacion_continua = true;
          } else if (p.id == 335) {
            img = 'img/fc_comercio_v3.png';
            this.is_formacion_continua = true;
          } else if (p.id == 342) {
            img = 'img/fc_camaras_v1.png';
            this.is_formacion_continua = true;
          } else if (p.id == 341) {
            img = 'img/fc_mantenimiento_v2.png';
            this.is_formacion_continua = true;
          } else if (p.id == 340) {
            img = 'img/fc_mantenimiento_v1.png';
            this.is_formacion_continua = true;
          } else if (p.id == 339) {
            img = 'img/fc_robotica_v1.png';
            this.is_formacion_continua = true;
          } else if (p.id == 457) {
            img = 'img/fc_herramientas_v1.png';
            this.is_formacion_continua = true;
          } else if (p.id == 443) {
            img = 'img/fc_sspp.jpg';
            this.is_formacion_continua = true;
          } else if (p.id == 444) {
            img = 'img/fc_investigacion_v1.jpg';
            this.is_formacion_continua = true;
          } else if (p.id == 446) {
            img = 'img/fc_redaccion_v1.jpg';
            this.is_formacion_continua = true;
          } else if (p.id == 456) {
            img = 'img/fc_mantenimiento_v22.jpg';
            this.is_formacion_continua = true;
          } else if (p.id == 489) {
            img = 'img/fc_finanzas.png';
            this.is_formacion_continua = true;
          } else if (p.id == 490) {
            img = 'img/fc_macros_v2.png';
            this.is_formacion_continua = true;
          } else if (p.id == 491) {
            img = 'img/fc_macros_v3.png';
            this.is_formacion_continua = true;
          } else if (p.id == 513) {
            img = 'img/fc_aduanerav4.png';
            this.is_formacion_continua = true;
            this.is_fc_id498 = true;
          } else if (p.id == 517) {
            img = 'img/fc_herramientasdigv2.png';
            this.is_formacion_continua = true;
          } else if (p.id == 559) {
            img = 'img/fc_gestionherra_v1.png';
            this.is_formacion_continua = true;
          } else if (p.id == 498) {
            this.is_fc_id498 = true;
            this.is_formacion_continua = true;
          } else if (p.id == 594) {
            img = 'img/fc_pagosv1.png';
            this.is_formacion_continua = true;
          } else if (p.id == 605) {
            img = 'img/fc_macros_v4.png';
            this.is_formacion_continua = true;
          } else if (p.id == 684) {
            img = 'img/fc_plataformaeducativas.png';
            this.is_formacion_continua = true;
          } else if (p.id == 685) {
            img = 'img/fc_plamoodle.png';
            this.is_formacion_continua = true;
          } else if (p.id == 686) {
            img = 'img/fc_plachamilo.png';
            this.is_formacion_continua = true;
          } else if (p.id == 687) {
            img = 'img/fc_plaedmodo.png';
            this.is_formacion_continua = true;
          } else if (p.id == 688) {
            img = 'img/fc_placlassroom.png';
            this.is_formacion_continua = true;
          } else if (p.id == 704) {
            img = process.env.VUE_APP_DOMAIN + 'certificados_fc/excel2021.png';
            this.is_formacion_continua = true;
            this.is_fc_id498 = true;
          } else if (p.id == 707) {
            img = process.env.VUE_APP_DOMAIN + 'certificados_fc/auxiliaradministrativo.jpg';
            this.is_formacion_continua = true;
          } else if (p.id == 706) {
            img = process.env.VUE_APP_DOMAIN + 'certificados_fc/certificado-ensamblado-de-computadoras.png';
            this.is_formacion_continua = true;
            this.is_fc_id498 = true;
          } else if (p.id == 693) {
            img = process.env.VUE_APP_DOMAIN + 'certificados_fc/herramientas-digitales-en-tiempo-de-pandemia.png';
            this.is_formacion_continua = true;
            this.is_fc_id498 = true;
          } else if (p.id == 752) {
            img = 'img/derecholaboral.jpg';
            this.is_formacion_continua = true;
            this.is_fc_id498 = true;
          } else if (p.id == 753) {
            img = 'img/gestionaduanera.jpg';
            this.is_formacion_continua = true;
            this.is_fc_id498 = true;
          } else if (p.id == 789) {
            img = 'img/gestionaduanera.jpg';
            this.is_formacion_continua = true;
            this.is_fc_id498 = true;
          } else if (p.id == 788) {
            img = 'img/gestionaduanera.jpg';
            this.is_formacion_continua = true;
            this.is_fc_id498 = true;
          } else if (p.id == 790) {
            img = 'img/gestionaduanera.jpg';
            this.is_formacion_continua = true;
            this.is_fc_id498 = true;
          } else if (p.id == 854) {
            img = process.env.VUE_APP_DOMAIN + 'webdata/bgcertificados/cert-60649362c86518.82623713.jpeg';
            this.is_formacion_continua = true;
            this.is_fc_id854 = true;
          } else if (p.id == 875) {
            img = process.env.VUE_APP_DOMAIN + 'webdata/bgcertificados/cert-606e135af30852.79296777.jpeg';
            this.is_formacion_continua = true;
            this.is_fc_id854 = true;
          } else if (!p.universidad || p.universidad.id == 9) img = 'img/certsigloxxx.jpg';
          else if (!p.universidad || p.universidad.id == 52) img = 'img/webina.png';
          // window.console.log( 'WEBINAR::::',p.universidad );

          if (p.postgrado.categoria.id == 104 && p.id != 602) {
            this.is_formacion_continua = true;
            this.is_fc_id498 = true;
          } else if (p.id == 1159) {
            this.is_formacion_continua = true;
          } else if (p.id == 1161) {
            this.is_formacion_continua = true;
            this.is_formacion_continua_esam = true;
          } else if (
            p.id == 899 ||
            p.id == 522 ||
            p.id == 744 ||
            p.id == 925 ||
            p.id == 926 ||
            p.id == 924 ||
            p.id == 923 ||
            p.id == 980 ||
            p.id == 978 ||
            p.id == 981 ||
            p.id == 1032 ||
            p.id == 924 ||
            p.id == 1094 ||
            p.id == 1095 ||
            p.id == 1096 ||
            p.id == 1125 ||
            p.id == 1122 ||
            p.id == 1124 ||
            p.id == 1098 ||
            p.id == 1097 ||
            p.id == 1160 ||
            p.id == 1123 ||
            p.id == 1158 ||
            p.id == 1197 ||
            p.id == 1636
          ) {
            this.is_formacion_continua = true;
            this.is_fc_id854 = true;
          } else if (
            p.id == 1120 ||
            p.id == 439 ||
            p.id == 252 ||
            p.id == 253 ||
            p.id == 322 ||
            p.id == 606 ||
            p.id == 540 ||
            p.id == 552 ||
            p.id == 592 ||
            p.id == 484 ||
            p.id == 689 ||
            p.id == 199 ||
            p.id == 1215 ||
            p.id == 1217 ||
            p.id == 1162 ||
            p.id == 1359 ||
            p.id == 1344 ||
            p.id == 1543 ||
            p.id == 1544 ||
            p.id == 1545 ||
            p.id == 1611 ||
            p.id == 1560
          ) {
            this.is_only_nombres = true;
          } else if (p.id == 1589) {
            this.is_only_nombresv2 = true;
          }

          if (!p.universidad || p.universidad.id == 2) img = 'img/uajms_cer.png';
          window.console.log(p.sede);
          if (p.sede.nombre.toLowerCase().includes('cca')) {
            img = 'img/cca_fondo.png';
          }

          this.originalimg = img;
          this.cargarFondoCertificado(img);

          this.programita = p;
          //window.console.log( 'PROGRMAITA:',this.programita )
          this.sede_certificado = p.sede.id == this.$store.state.CARGO.idsede;
          if (p) {
            this.idprograma = p.id;
            this.listarEstudiantes();
          }

          this.getpostitulos(p.id);
        }

        window.$('#modal-cert').on('hidden.bs.modal', function () {
          var destinationCanvas = document.getElementById('myCanvasview');
          var destCtx = destinationCanvas.getContext('2d');
          destCtx.clearRect(0, 0, destinationCanvas.width, destinationCanvas.height);
          destinationCanvas.width = 0;
          destinationCanvas.height = 0;
          vue.mensajito = '';
        });
      },
    },
    async mounted() {
      this.$refs.refCertificadosTodosFecha.openmodal();
      this.getprogramabyid();
    },
  };
</script>
